"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageUpload = void 0;
var ImageUpload = (function () {
    function ImageUpload(element) {
        this.element = element;
        this.valid = true;
        this.OnCreate();
    }
    ImageUpload.prototype.OnCreate = function () {
        var _this = this;
        var validationLabel = _this.element.closest('.md-form').find('label.file-field.invalid');
        validationLabel.hide();
        var clearButton = _this.element.closest('.md-form').find(".clear-image-button");
        var imagePreview = _this.element.closest('.md-form').find('.img-preview');
        if (imagePreview.prop('src') === imagePreview.data('fallback-src'))
            clearButton.hide();
        this.element.on('change', function () {
            var htmlInputElement = _this.element.get(0);
            if (htmlInputElement && htmlInputElement.files) {
                var file = htmlInputElement.files[0];
                _this.Validate(file);
            }
        });
        clearButton.on('click', function (e) {
            _this.ResetFile();
            imagePreview.prop('src', imagePreview.data('fallback-src'));
            $("#".concat(_this.element.prop('id'), "IsDeleted")).val('true');
            clearButton.hide();
            _this.ToggleValidation(true);
        });
    };
    ImageUpload.prototype.Validate = function (file) {
        var _this = this;
        var img = new Image();
        var imgwidth = 0;
        var imgheight = 0;
        var maxwidth = _this.element.data('maxwidth');
        var maxheight = _this.element.data('maxheight');
        var maxfilesize = _this.element.data('maxfilesize');
        img.src = window.URL.createObjectURL(file);
        img.onload = function () {
            imgwidth = img.width;
            imgheight = img.height;
            if ((maxfilesize > 0 && file.size > maxfilesize) ||
                (maxwidth > 0 && imgwidth > maxwidth) ||
                (maxheight > 0 && imgheight > maxheight)) {
                _this.valid = false;
                _this.ToggleValidation(false);
            }
            else {
                _this.valid = true;
                var clearButton = _this.element.closest('.md-form').find(".clear-image-button");
                clearButton.show();
                $("#".concat(_this.element.prop('id'), "IsDeleted")).val('false');
                var reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = function (e) {
                    var imagePreview = _this.element.closest('.md-form').find('.img-preview');
                    imagePreview.prop('src', e.target.result);
                    imagePreview.show();
                };
                _this.ToggleValidation(true);
            }
        };
    };
    ImageUpload.prototype.ResetFile = function () {
        var _this = this;
        _this.element.wrap('<form>').closest('form').get(0).reset();
        _this.element.unwrap();
    };
    ImageUpload.prototype.ToggleValidation = function (valid) {
        var _this = this;
        var validationLabel = _this.element.closest('.md-form').find('label.file-field.invalid');
        var imgLabel = _this.element.closest('.md-form').find('label.img-label');
        var divFileField = _this.element.closest('div.file-field');
        if (!valid) {
            validationLabel.text(_this.element.data('error'));
            validationLabel.show();
            divFileField.addClass('invalid');
            imgLabel.addClass('invalid');
            _this.ResetFile();
        }
        else {
            validationLabel.hide();
            divFileField.removeClass('invalid');
            imgLabel.removeClass('invalid');
        }
    };
    return ImageUpload;
}());
exports.ImageUpload = ImageUpload;
